import '../wwwroot/js/care-list.js';
import '../wwwroot/js/admission-product.js';
import './styles/main.scss';
import 'bootstrap';
import htmx from 'htmx.org';

// Shared page scripts use the same bundled HTMX instance for lazy details.
(window as any).htmx = htmx;

import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/fill';
import '@phosphor-icons/web/duotone';

// ── Controles modernos (ver app/frontend/UI-CONTROLS.md) ────────────────────
// CSS de las librerías (con tema Bootstrap 5 donde existe) + overrides de marca.
import 'tom-select/dist/css/tom-select.bootstrap5.css';
import 'flatpickr/dist/flatpickr.min.css';
import 'tabulator-tables/dist/css/tabulator_bootstrap5.min.css';
import './styles/_controls.scss';
import './controls/index';
import './remote-select-loader';
import './controls/captura-qr';
import './global-loading';
import './profint-clinical-assistant';
import './profint-smart-task';
import './shell-navigation';
import './licencias-agenda-editor';
import './licencias-protocol-editor';
import './communications-workspace';
import './clinical-coverage';
import './clinical-assignment';
import './practice-provider';
import './presence-controls';
import './user-actions-menu';
import './patient-search';
import './clinical-admission';
import './license-capture-quality';
// Load the PDF merger only when staff open the scanned clinical history.
window.profintMergePatientHcPdfs = async (urls: string[]) => {
  const { mergePatientHcPdfs } = await import('./hc-record-pdf');
  return mergePatientHcPdfs(urls);
};

// ----------------------------------------------------------------------------
// Submit spinner — para botones submit que dispararían un POST con I/O lento
// (mail, gateway REST). Atributo opt-in:
//
//   <button type="submit"
//           data-submit-spinner
//           data-spinner-icon="ph-envelope-simple"
//           data-spinner-label="Enviando…">
//     Enviar instrucciones
//   </button>
//
// Espejo del helper del cliente portal — duplicado por bundle aparte.
// ----------------------------------------------------------------------------
// Submit progress and restoration are owned by shared-operation-controls.

// Mostrar u ocultar la contraseña en formularios de acceso.
// Existing password markup is adopted by the shared text/access controller.
import './entity-metadata';
